import { plural } from '@cian/utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { closeModal, setOption } from '../../../actions/print';
import { ModalPrint } from '../../../components/MassActions/print/ModalPrint';
import { selectOptions } from '../../../selectors/print/selectOptions';
import { selectSelectedEntitiesCount } from '../../../selectors/selected';

interface IProps {
  onConfirm(): void;
}

export function ModalPrintContainer({ onConfirm }: IProps) {
  const dispatch = useDispatch();
  const options = useSelector(selectOptions);
  const count = useSelector(selectSelectedEntitiesCount);

  const handleChangeOption = (optionName: string, value: boolean) => {
    dispatch(
      setOption({
        optionName,
        value,
      }),
    );
  };

  const confirmText = `Распечатать ${count} ${plural(count, ['объявление', 'объявления', 'объявлений'])}`;

  return (
    <ModalPrint
      options={options}
      text={confirmText}
      onChangeOption={handleChangeOption}
      onCancel={() => dispatch(closeModal())}
      onPrint={onConfirm}
    />
  );
}
